import React, { useEffect, useState, ReactNode } from "react";
import { Banner, BannerProps } from "kubra-ux-forge";
import { getBannerRole } from "utilities/banner-accessibility";

export const BannerProvider = ({
  children,
}: {
  children: (
    setBannerState: React.Dispatch<React.SetStateAction<BannerProps>>,
  ) => ReactNode;
}) => {
  const [bannerState, setBannerState] = useState<BannerProps>({
    active: false,
    variant: "error",
    messageLabel: "",
  });

  useEffect(() => {
    if (bannerState.active) {
      document.body.scrollTop = 0;
      document.documentElement.scrollTop = 0;
      window.scrollTo({ top: 0, behavior: "smooth" });
    }
  }, [bannerState.active]);

  return (
    <>
      {bannerState.active && (
        <div
          className="ez-pay-payable-banner"
          role={getBannerRole(bannerState.variant)}
        >
          <Banner
            {...bannerState}
            data-cy={
              bannerState?.variant
                ? `banner-${bannerState.variant}-content`
                : "banner-info-content"
            }
            onClose={() =>
              setBannerState((prev) => ({ ...prev, active: false }))
            }
          ></Banner>
        </div>
      )}
      {children(setBannerState)}
    </>
  );
};
